import React from 'react';
import { css, cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { theme } from '@frontend/theme';

type Props = CommonHTMLAttributes & {
  children: React.ReactNode;
  as?: React.ElementType;
  /**
   * For when ButtonBar is embedded in an element with external padding (eg Modal)
   * Only one of these props should be passed at once. They do not stack.
   */
  removeHorizontalSpacing?: boolean;
  removeSpacing?: boolean;
  removeVerticalSpacing?: boolean;
};

const buttonBarBaseStyle = css`
  width: 100%;
  background: white;
  display: flex;
  justify-content: end;
  gap: ${theme.spacing(1)};
`;

const buttonBarDefaultSpacingStyle = css`
  padding: ${theme.spacing(2)};
`;

const buttonBarNoHorizontalSpacingStyle = css`
  padding: ${theme.spacing(2, 0)};
`;

const buttonBarNoVerticalSpacingStyle = css`
  padding: ${theme.spacing(0, 2)};
`;

export const ButtonBar = ({
  children,
  as = 'div',
  removeHorizontalSpacing,
  removeSpacing,
  removeVerticalSpacing,
  className,
  ...rest
}: Props) => {
  const Component = as;

  const spacingClass = removeSpacing
    ? undefined
    : removeHorizontalSpacing
    ? buttonBarNoHorizontalSpacingStyle
    : removeVerticalSpacing
    ? buttonBarNoVerticalSpacingStyle
    : buttonBarDefaultSpacingStyle;

  return (
    <Component className={cx(buttonBarBaseStyle, spacingClass, className)} {...rest}>
      {children}
    </Component>
  );
};
